/**
 * @callback CallForEachChild
 * @param {object} marker - The marker to call the function on.
 * @param {string} path - The dot-delimited path to the marker.
 * @param {string} markerType - The type of the marker.
 * @param {string} markerId - The id of the marker.
 * @param {object} parentMarker - The parent marker.
 * @returns {void|boolean} If true, traversal stops.
 */

/**
 * Traverse a tree of markers, calling a function on each marker (and its children). If any child callback returns true, traversal stops and
 * the function returns true.
 * @param {object} markerData - The marker data to traverse (either `photofirst_data` or `marker._children`).
 * @param {CallForEachChild} callForEachChild - The function to call on each marker. If the function returns true, traversal stops.
 * @param {string[]} [path] - The path to the current marker.
 * @param {object} [topParent] - The top parent marker.
 * @param {string[]|null} [excludedMarkerTypes=null] - An array of marker types to exclude from traversal. Defaults to `null`.
 */
export function TraverseMarkers(markerData, callForEachChild, path, topParent, excludedMarkerTypes = null) {
  path = path || [];
  for (let markerType in markerData) {
    // Skip excluded marker types if provided.
    if (excludedMarkerTypes && excludedMarkerTypes.includes(markerType)) {
      continue;
    }
    for (let markerId in markerData[markerType]) {
      let marker = markerData[markerType][markerId];
      if (marker) {
        let parent = topParent || marker;
        let markerPath = path.concat([markerType, markerId]);
        // If callForEachChild returns true, stop execution.
        let stop = callForEachChild(marker, markerPath.join('.'), markerType, markerId, parent);
        if (stop) return stop;
        if (marker._children) {
          let stop = TraverseMarkers(marker._children, callForEachChild, markerPath.concat('_children'), parent, excludedMarkerTypes);
          if (stop) return stop;
        }
      }
    }
  }
}
